export enum AudioNetworkStates {
  NETWORK_EMPTY = 0, // audio/video has not yet been initialized
  NETWORK_IDLE, // audio/video is active and has selected a resource, but is not using the network
  NETWORK_LOADING, // browser is downloading data
  NETWORK_NO_SOURCE // no audio/video source found
}
